import React from 'react'
import { observer } from 'mobx-react'
import { action } from 'mobx'
import { Row, Col, Dropdown, Button } from 'react-bootstrap'
import sortBy from 'lodash/sortBy'
import isObject from 'lodash/isObject'
import {
  IoIosEye as VisibilityOn,
  IoIosEyeOff as VisibilityOff,
} from 'react-icons/io'
import { isMerchPLP } from 'config/appConfig'
import { handleFilterCbk } from 'src/deps'
import { merchProductContainer } from 'src/models'
import { application, setResponsiveValues } from 'src/utils'
import { AccordionBlock, ProductDragAndDrop } from 'src/views/components'
import { ListView } from '../ListView'
import { MobileFilterHeader } from '../MobileFilterHeader'
import './styles.scss'

@observer
class DropdownFilter extends React.Component {
  @action
  saveLayout = (layout, cols) => {
    merchProductContainer.facetPositions = sortBy(
      layout.map(data => {
        return {
          facetId: data.i,
          position: data.y * cols + data.x + 1,
        }
      }),
      ['position']
    )
  }

  @action
  handleVisibility = name => {
    if (isMerchPLP) {
      const facetPositions = merchProductContainer.facetPositions
      const currentIndex = facetPositions.findIndex(
        facet => facet.facetId === name
      )
      const visible = facetPositions[currentIndex].visible
      merchProductContainer.facetPositions =
        merchProductContainer.facetPositions.map((data, index) => {
          if (index !== currentIndex) {
            return { ...data }
          } else {
            return {
              ...data,
              visible:
                visible === undefined || visible === '' || visible === true
                  ? false
                  : true,
            }
          }
        })
    }
  }

  componentDidMount() {
    if (isMerchPLP) {
      merchProductContainer.setFacetPositions(this.props.facetFilter)
    }
  }

  handleClick = (name, value) => {
    handleFilterCbk({ props: { ...this.props }, nameValue: { name, value } })
  }

  renderDropdownFilter = props => {
    const { listItem: filter, facetPositions } = props
    const name = filter.name
    const facetData = facetPositions.find(facet => facet.facetId === name)
    const count = filter.values.filter(item => item.selected === true).length
    return (
      <Dropdown
        drop="down"
        className={`w-100 dropdown-filter bg-white  ${
          isMerchPLP
            ? `merch-filter ${
                isObject(facetData) && facetData.visible === false
                  ? 'not-visible'
                  : ''
              }`
            : ''
        }`}
        role="menuitemcheckbox"
        {...(isMerchPLP && {
          show: false,
        })}>
        <Dropdown.Toggle
          variant=""
          {...(isMerchPLP && {
            onClick: () => this.handleVisibility(name),
          })}
          className={`w-100 border rounded text-left p-2 d-flex justify-content-between`}>
          {filter.name}
          {count > 0 && (
            <span className="text-danger pl-2">{`(${count})`}</span>
          )}
          {isMerchPLP &&
            (isObject(facetData) &&
            (facetData.visible === undefined ||
              facetData.visible === '' ||
              facetData.visible === true) ? (
              <VisibilityOff size="1.5rem" className="allow-merchplp" />
            ) : (
              <VisibilityOn size="1.5rem" className="allow-merchplp" />
            ))}
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100 p-2">
          <ListView
            item={filter}
            className="check-box-wrap mb-2 text-break"
            handleClick={this.handleClick}
          />
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  render() {
    const selectedFacets = []
    const { facetFilter, toggleFilter, handleFilter } = this.props
    Object.values(facetFilter).forEach(facet => {
      const facetArray = facet.values.filter(item => item.selected === true)
      if (facetArray.length > 0) {
        selectedFacets[facet.key] = facetArray
      }
    })
    const selectedFacetsArray = Object.values(selectedFacets).map(item => {
      const { ...destructeredArray } = item
      return destructeredArray
    })
    return (
      <>
        {application.isTabletOrLarger && (
          <Row noGutters className="mt-3">
            <Col className="d-flex">
              <div className="text-uppercase pr-3 font-weight-bold mb-4">
                Filters
              </div>
              {selectedFacetsArray.length > 0 && (
                <div className="text-uppercase">
                  {selectedFacetsArray.length} Filters applied
                </div>
              )}
            </Col>
            <Col className="text-right">
              <Button
                className="bg-transparent border-0 text-dark"
                onClick={() => {
                  this.props.handleFilter()
                }}>
                Clear All
              </Button>
            </Col>
          </Row>
        )}

        {application.isMobile ? (
          <>
            <MobileFilterHeader
              toggleFilter={toggleFilter}
              handleReset={handleFilter}
            />
            <ol className="facet-list pl-0">
              {this.props.facetFilter.map((item, index) => (
                <AccordionBlock
                  key={`filter-accordion_${index}`}
                  className="filter-facet p-2 border-bottom border-light-grey"
                  dataTestId="qa-plp-filter"
                  title={item.name}
                  index={index}>
                  <ol className="facet-list p-0 m-0 pt-3">
                    <fieldset>
                      <legend>{item.name}</legend>
                      <ListView
                        item={item}
                        className="check-box-wrap mb-2 text-break"
                        handleClick={this.handleClick}
                      />
                    </fieldset>
                  </ol>
                </AccordionBlock>
              ))}
            </ol>
          </>
        ) : (
          <ProductDragAndDrop
            useDragAndDrop={isMerchPLP}
            cardHeight={50}
            additionalProps={{
              facetPositions: merchProductContainer.facetPositions,
            }}
            cols={setResponsiveValues(5, 4, 3)}
            list={this.props.facetFilter.map(filter => {
              return { identifier: filter.name, ...filter }
            })}
            saveLayout={this.saveLayout}
            renderFunction={this.renderDropdownFilter}
            wrapper={children => (
              <div noGutters className="filter-list-wrap mb-4">
                {children}
              </div>
            )}
          />
          /*  <div noGutters className="filter-list-wrap mb-4">
            {this.props.facetFilter.map(this.renderDropdownFilter)}
           </div>*/
        )}
      </>
    )
  }
}

export { DropdownFilter }
